import React, { FC } from 'react';
import { useHasComponent, useOrchestratorState, StepRenderer } from '@wix/gg-common-lib/orchestrator';
import { Box, Loader } from '@wix/design-system';
import styles from './App.scss';
import { StepParams, StepRenderPart } from 'types/steps';
import { Header } from 'components/Header/Header';
import { HeaderLogo } from 'components/Header/HeaderLogo';
import { useIsMobile } from '@wix/gg-common-lib/hooks';
import { DynamicSplitLayout } from '@wix/gg-common-lib/components';
import clsx from 'clsx';

export const AppLayout: FC = () => {
  const { isLoading, currentParams } = useOrchestratorState<StepParams>();
  const isMobile = useIsMobile();
  const hasMainComponent = useHasComponent<StepRenderPart>('main');
  const hasSideComponent = useHasComponent<StepRenderPart>('side');

  if (isLoading) {
    return (
      <Box align="center" verticalAlign="middle" height="100vh" width="100vw">
        <Box direction="vertical" align="center" gap={10}>
          <HeaderLogo />
          <Loader />
        </Box>
      </Box>
    );
  }

  if (!hasMainComponent && !hasSideComponent) {
    return <StepRenderer />;
  }

  return (
    <div className={styles.appLayout}>
      <div className={styles.appLayoutHeader}>
        <Header />
      </div>
      <div className={styles.appLayoutBody}>
        <DynamicSplitLayout ratio={currentParams?.splitRatio}>
          <div className={styles.appLayoutBodyMain}>
            <StepRenderer componentKey="main" />
          </div>
          {hasSideComponent && !isMobile && (
            <div className={clsx(styles.appLayoutBodySide, !hasMainComponent && styles.single)}>
              <div className={styles.appLayoutBodySideContent}>
                <StepRenderer componentKey="side" />
              </div>
            </div>
          )}
        </DynamicSplitLayout>
      </div>
    </div>
  );
};
